import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import numberbeautify from "../../utils/numberbeautify";
import money_rounding from "../../utils/money_rounding";
import iqd_rounding from "../../utils/iqd_rounding";

const Customertable = () => {
    const { initState, recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);
    const [invoice,setinvoice]=useState([]);
    const [loan,setloan]=useState([]);

    const [show,setshow]=useState(false);
    const [show1,setshow1]=useState(false);
    return (
        <div>
            <div className="container mx-auto px-4 sm:px-8">
        <div className="py-8">
          <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
            <div className="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
              <table className="min-w-full leading-normal">
                <thead>
                  <tr>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    ناوی کڕیار
                    </th>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    ژمارە
                    </th>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    کۆی فرۆش
                    </th>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    کۆی فرۆش بە قەرز
                    </th>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    قەرزی گەڕاوە
                    </th>
                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    قەرزی ماوە
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {initState.customer_report.map((lis)=>(
                    <tr key={lis.customer_id}>
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <p className="text-gray-900 whitespace-no-wrap">
                      {lis.customer_name}
                    </p>
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <p className="text-gray-900 whitespace-no-wrap">
                      {lis.customer_phone}
                    </p>
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <p className="text-gray-900 whitespace-no-wrap">
                       {numberbeautify(iqd_rounding(money_rounding(lis.total_sold_price)))} IQD
                    </p>
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <p className="text-gray-900 whitespace-no-wrap">
                        {numberbeautify(iqd_rounding(money_rounding(lis.total_sold_loan)))} IQD
                    </p>
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <p className="text-gray-900 whitespace-no-wrap">
                        {numberbeautify(iqd_rounding(money_rounding(lis.total_loan_in)))} IQD
                    </p>
                  </td>
                  <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                    <p className="text-gray-900 whitespace-no-wrap">
                        {numberbeautify(iqd_rounding(money_rounding(lis.summary_of_loan)))} IQD
                    </p>
                  </td>
                  </tr>
                  ))}
                </tbody>
                </table>
                </div>
                </div>
                </div>
                </div>
        </div>
    )
}

export default Customertable